import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const CUSTOMER_PROFILE_TABS = {
  ORDER_HISTORY: "orderHistory",
  SOP_STATUS: "sopStatus",
  COUPONS: "coupons",
  KEY_INFO: "keyInformation",
  NOTES: "notes",
};

export type CustomerProfileTabs = (typeof CUSTOMER_PROFILE_TABS)[keyof typeof CUSTOMER_PROFILE_TABS];

interface DownlineProfileState {
  affAbo: string;
  activeTab: CustomerProfileTabs;
  history: string[];
}

export const initialState: DownlineProfileState = {
  affAbo: "",
  activeTab: "keyInformation",
  history: [],
};
const { actions, reducer } = createSlice({
  name: "aboDownlineProfile",
  initialState,
  reducers: {
    setSelectedDownlineProfile: (state, action: PayloadAction<string>) => {
      state.affAbo = action.payload;
    },
    setActiveTab: (state, action: PayloadAction<CustomerProfileTabs>) => {
      state.activeTab = action.payload;
    },
    resetHistory: (state, action: PayloadAction<string>) => {
      const [aff, abo] = action.payload?.split("-") ?? [];
      const normalized = aff && abo ? `${aff.padStart(3, "0")}-${abo}` : action.payload;

      state.history = normalized ? [normalized] : [];
      state.affAbo = normalized || state.affAbo;
    },
    pushToHistory: (state, action: PayloadAction<string>) => {
      if (state.history.includes(action.payload)) return;
      state.history.push(action.payload);
      state.affAbo = action.payload;
    },
    goBackInHistory: (state) => {
      if (state.history.length > 0) state.history.pop();
      state.affAbo = state.history.at(-1) ?? state.affAbo;
    },
  },
});

export const { setSelectedDownlineProfile, setActiveTab, resetHistory, pushToHistory, goBackInHistory } = actions;

export default reducer;
